import React, { useEffect, useRef,  useState} from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import { Button } from '../styles/Button';
import axios from "axios";
import FormatPrice from '../Helpers/FormatPrice'
import { useAuthStore } from "../store/store"; // adjust path
import PageHeader from "../components/PageCloseButton";


const OrderPrint = () => {
const printRef = useRef(null);
const { id } = useParams();
const { auth } = useAuthStore();
const [order, setOrder] = useState(null);

// GET SINGLE ORDER
  const getSingleOrder = async () => {
    try {
      const { data } = await axios.get(
        `/api/orders/${id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      console.log("Single Order:", data);
      setOrder(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token && id) {
      getSingleOrder();
    }
  }, [auth?.token, id]);

 const SubTotal =
  order?.products?.reduce(
    (sum, item) => sum + item.quantity * item.price,
    0
  ) || 0;

const shippingCharges = order?.shippingCharges || 0; // define shipping fee properly

  // PRINT
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Order-${order?.orderNumber}`,

    pageStyle: `
      @page {
        size: A4;
        margin: 0;
      }

      body {
        margin: 0 !important;
        padding: 0 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        
        }

      .a4-page {
        width: 210mm !important;
        min-height: 297mm !important;
        padding: 4rem!important;
        box-sizing: border-box !important;
        background: white !important;
        margin: 0 auto !important;
        }
      
        h1{
        text-align: center !important;
        font-size: 20px !important;
        margin-bottom: 0.8rem !important;
        text-align: center;
      }
    
       h2{
        text-align: center;
         font-size: 12px !important;
         margin: 0.8rem;
        }
    
      h3 {
        margin-top: 1rem !important;
        text-align: center;
        font-size: 15px !important;
        margin-bottom: 0.5rem !important;
        
      }

    span{
      display: flex;
      justify-content: space-between;
      }
 
    .order-info {
      margin-bottom: 1rem !important;
       text-align:left;
      }

    .order-info p {
      font-size: 12px !important;
      margin: 5px 0 !important;
      }

    table {
      width: 100% !important;
      border-collapse: collapse !important;
      margin-top: 1.5rem !important;
      text-transform: capitalize;
      }
   
    table,
    th,
    td {
      border: 1px solid black !important;
      }

      th,
      td {
        padding: 0.8rem !important;
        font-size: 15px !important;
      }

      .Terms-Conditions h3{
        text-align:left;
        }
       .Terms-Conditions ol {
        padding-left: 1.rem;
        font-size: 12px;
        line-height: 1.6; 
        }
      

      .total-section {
        margin-top: 2px !important;
        text-align: right !important;
      }

      .total-section h3 {
        font-size: 5px !important;
      }
    .close-btn {
    display: none;
        
    `,
  });

  if (!order) {
    return <h2>Loading...</h2>;
  }

  return (
    <Wrapper>
      {auth.role=='user'?
      <Button  className="print-btn" onClick={handlePrint}>
        Print
      </Button>:<></>}

      {/* SAME PREVIOUS STYLING */}
      <div ref={printRef} className="a4-page">
        
        <PageHeader title="" />

        <div className="header">
            <h1>CIANA HOME PRODUCTS LLP </h1>
            <h2>602, Q-BLOCK, SHYAM HILLS,<br />
            Nr GST OVERBRIDGE, NEW RANIP <br /> 
            AHMEDABAD - 382470 (GUJARAT)<br />
            INDIA <br />
            Ph No : +91 96648 36525     ||    Email: info@ciana.in</h2>
           
        </div>
        <hr />
       <h3>Request for Final Quote</h3>
        <div className="order-info">
          <span>
           <p> <strong>RFQ No :</strong>{" "}
            {order.orderNumber} </p>
          <p>
            <strong>Date:</strong>{" "}
            {new Date(order.createdAt).toLocaleDateString("en-GB")}
          </p>
          </span>

          <p>
              <strong>From : <br/></strong> {order.address?.name}
          </p>

          <p>
            <strong>Address</strong><br />
            {order.address?.street_add}<br />
            {order.address?.city} - {order.address?.zipcode} ({order.address?.state_province})<br />
            {order.address?.country}
          </p>

          <p>
            <strong>Email:</strong>{" "}
            {order.buyer?.email}
          </p>

          <p>
             <strong>Phone:</strong> {order.buyer?.mobile}
          </p>
        </div>

        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Item</th>
              <th>Qty (Pcs)</th>
              <th>Price </th>
              <th>Amount </th>
            </tr>
          </thead>

          <tbody>
            {order.products?.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td>
                  {item.productId?.SKU} {item.productId?.name} - {(item.productId?.Item)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.quantity}
                </td>
                <td style={{ textAlign: "right" }}>
                  <FormatPrice price={item.price} />
                </td>
                <td style={{ textAlign: "right" }}>
                  <FormatPrice price={item.quantity * item.price} />
                </td>
              </tr>
               ))}

           {/* Subtotal Row with Quantity */}
            <tr style={{ backgroundColor:"#cfcece", fontWeight: "bold" }}>
                <td colSpan={2} style={{ textAlign: "left", fontWeight: "bold" }}>
                  Sub Total (FOB)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {order.products?.reduce((acc, item) => acc + item.quantity, 0)}
                </td>
                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                  {/* leave blank or label */}
                </td>
                <td style={{ textAlign: "right" }}>
                  <FormatPrice
                    price={order.products?.reduce(
                    (acc, item) => acc + item.quantity * item.price,
                    0
                    )}/>
                </td>
              </tr>
            {/* Shipping Charges Row */}
            <tr>
              <td colSpan={4} style={{ textAlign: "left", fontWeight: "bold" }}>
                Sea Freight (1 x 20PG)
              </td>
              <td style={{ textAlign: "right" }}>
                <FormatPrice price={order.shippingCharge || 0} />
              </td>
            </tr>

            {/* Total Amount Row */}
            <tr>
              <td colSpan={4} style={{ textAlign: "left", fontWeight: "bold" }}>
                Total Amount ( C&F)
              </td>
              <td style={{ textAlign: "right" }}>
               <FormatPrice price={order.orderTotal} />
              </td>
            </tr>
          </tbody>
        </table>
       <div className="Terms-Conditions">
          <h3>Terms & Conditions</h3>
          <ol>
            <li>
              1. Price : above are on C & F. Insurance would be covered by buyer.
              Third party inspection if required will be charged extra.
            </li>
            <li>
             2. Price mentioned: above is for supply of products only. Installation, Testing & Commissioning
              would be arranged and paid by you.
            </li>
            <li>
              3. Payment Term: 40% advance with order and balance payment against copy of shipping documents on mail.
            </li>
            <li>
              4. Delivery Term: Material will be dispatched within 3-4 weeks time after receipt of confirmed order with payment detail.
            </li>
            <li>
              5. Packing: Corrugated Card Box.
            </li>
            <li>
              6. Acceptable tolerance of qty and value should be plus or minus 10%.
            </li>
            <li>
             7. Validity: This PI is valid till 90 days from the issue date.
            </li>
            <li>
              8. Force Majeure clause will apply.
            </li>
          </ol>
        </div>
        <hr />

      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #efefef;
  min-height: 100vh;
  padding: 1rem;

  .print-btn {
    margin: 2rem;
  }

  .a4-page {
    width: 210mm;
    min-height: 297mm;
    padding: 10mm;
    margin: auto;
    background: white;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  }

   h1{
    font-size: 25px;
    }

  h2{
    font-size: 15px;
    margin: 1rem;
    }

  h3 {
    text-align: center;
    font-size: 20px;
    margin-bottom: 1rem;
    margin-top: 1rem;
    font-weight: bold;
  
  }
 

  .order-info {
    margin-bottom: 2.5rem;
    }

  span{
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    }

  .order-info p {
    font-size: 15px;
    margin: 0.5rem 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 2rem;
    text-transform: capitalize;
    }
 thead {
    background-color:${({ theme }) => theme.colors.bgd};
    color: #fff;
  }

  table,
  th,
  td {
    border: 1px solid black;
  }

  th,
  td {
    padding: 1rem;
    font-size: 15px;
    }

  .total-section {
    margin-top: 2rem;
    text-align: right;
  }

  .total-section h3 {
    font-size: 25px;
    margin: 0;
  }
  
 .header {
  left: 0;
  width: 100%;          
  text-align: center;   
  font-size: 15px;
  padding: 10px 0;  
  margin-top: 1rem;   
  }
.order-total--amount {
  text-transform: capitalize;
  display: flex;
  justify-content: flex-end;
  }
    
.Terms-Conditions {
  
  h3{
  text-align: left;
  }
  ol {
   padding-left: 1.5rem;
   font-size: 12px;
   line-height: 1.6; 
   }

}


  @media print {
    .print-btn {
      display: none;
    }

    .a4-page {
      box-shadow: none;
      border: 2px solid black !important;
    }
      
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}){
  .a4-page {
    width: 100% !important;
    min-height: auto !important;
    padding: 1rem !important;
    margin: 0 !important;
  }

  h1 {
    font-size: 16px !important;
    margin-bottom: 0.5rem !important;
  }

  h2 {
    font-size: 12px !important;
    margin: 0.5rem !important;
  }

  h3 {
    font-size: 14px !important;
    margin: 0.5rem 0 !important;
  }

  .order-info p {
    font-size: 11px !important;
  }

  table,
  th,
  td {
    font-size: 12px !important;
    padding: 0.5rem !important;
  }

  .total-section h3 {
    font-size: 12px !important;
  }
}
`;

export default OrderPrint;